import {httpsCallable} from "firebase/functions";
// @ts-ignore -- "FirebaseUtils" is resolved by the web bundler, not by tsc
import {functions} from "FirebaseUtils";

/**
 * Wakes a rarely-used callable ahead of the moment the user will need it, so its
 * cold start overlaps something the user is already doing (reading a page,
 * picking a plan) instead of a spinner.
 *
 * The createCloudFunction wrapper in functions/index.ts recognises `__warmup`,
 * loads the route and returns before the handler runs: no side effects, so this
 * is safe for any callable declared through it.
 */

// Cloud Run keeps an idle instance for several minutes, so re-warming more often is wasted.
const REWARM_AFTER_MS = 5 * 60 * 1000;
const lastWarmedAt = new Map<string, number>();

export const warmUpFunction = (name: string): void => {
  const now = Date.now();
  if (now - (lastWarmedAt.get(name) ?? 0) < REWARM_AFTER_MS) {
    return;
  }
  lastWarmedAt.set(name, now);
  const warmUp = httpsCallable(functions, name);
  warmUp({__warmup: true}).catch(() => {
    // Best-effort: the real call still works, only slower. Allow a retry.
    lastWarmedAt.delete(name);
  });
};
